<template>
    <div class="employee-tab-inner">
        <!--<ul class="list-group mb-3 " v-if='errormsg'>
            <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
        </ul>-->
        <b-overlay :show="showoverlay" rounded="sm">
            <div class="pf-reporting-tab payroll-reporting-tab" id="nav-tabContent-intro2">



                <div class="">



                    <div v-if="reg_custom_list.length > 0">

                        <!-- Export Import Disabled Temporarily
                                         -->
                        <!-- <div class="card-header px-0 bg-transparent border-0">
                                    <div class="row no-margin">
                                    <div class="col-sm-6 pl-0" >
                                    <div class="employee-btn-holder" style="max-width:210px">
                                        <div class="report-intro" style="text-align:center">
                                            Bulk Import
                                        </div>
                                        <div  style="min-height:5px;">
                                        </div>

                                        <b-button @click="exportPFSelected" ><b-icon icon="code-slash" ></b-icon> Template</b-button>
                                        <b-button :href="$api_url+'/device-mapping/import/update'"><b-icon icon="box-arrow-up" class="" scale="1"></b-icon> Import</b-button>

                                    </div>
                                    </div>
                                    </div>
                                    </div>   -->

                        <div class="card-header px-0 bg-transparent border-0">
                            <div class="row no-gutters">

                                <div class="col-sm-6 pl-0">

                                    <!-- Title -->
                                    <div class="ibox-title dashboard_title px-0">
                                        <h4 class="mb-2 font-weight-bold">Bulk Import</h4>
                                    </div>

                                    <!-- Buttons -->
                                    <div class="d-flex">
                                        <b-button variant="primary" class="mr-2" @click="exportPFSelected">
                                            <b-icon icon="code-slash"></b-icon>
                                            Template
                                        </b-button>

                                        <b-button variant="primary" :href="$api_url + '/device-mapping/import/update'">
                                            <b-icon icon="box-arrow-up"></b-icon>
                                            Import
                                        </b-button>
                                    </div>

                                </div>

                            </div>
                        </div>




                        <common-list :checkbox="checkbox" :is_action="reg_is_action"
                            :appended_column="reg_appended_column" :key="reg_list_key"
                            :company_options="reg_company_options" :employees="reg_custom_list"
                            :default_column="reg_default_column" :primary_key="reg_primary_key"
                            v-on:childToParent="reg_listReturn"></common-list>
                    </div>
                    <div v-else>

                        <div v-if="show_loader_3" class="list-no-data">
                            <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo"
                                width="100px" />
                        </div>
                        <div v-else class="list-no-data">
                            Looks like there is no employee to show.
                        </div>

                    </div>
                </div>

            </div>



            <b-modal size="md" id="bv-modal-register-pf" hide-footer :title="'Add Device ID for ' + curr_emp_name">
                <div class="d-block">
                    <b-form @submit.stop.prevent="addEmployeeToPf">
                        <div class="clearfix">
                            <div class="row clearfix">
                                <div class="col-md-12 float-left">
                                    <b-form-group id="device_id-group" label="Device ID" class="" label-for="device_id">
                                        <b-input-group>
                                            <!-- alpha fix- added class radius-8 to input field -->
                                            <b-form-input class="radius-8" id="device_id" name="device_id" v-model="pf_approve_date"
                                                v-validate="{ min: 3, max: 10 }" :state="validateState('device_id')"
                                                aria-describedby="device_id-feedback"
                                                data-vv-as="Device ID"></b-form-input>
                                            <b-form-invalid-feedback id="device_id-feedback">{{
                                                veeErrors.first('device_id') }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>

                        <!-- alpha fix- added class text-center and removed class float-right from the btn  -->
                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 0;">
                            <b-button class="border rounded bg-light  py-1 px-5 mt-4 ml-2" type="submit"
                                variant="primary">Submit</b-button>
                        </div>
                    </b-form>
                </div>
            </b-modal>



            <b-modal size="md" id="bv-modal-update-pf" hide-footer
                :title="'Update Device ID for ' + curr_update_employee">
                <div class="d-block">
                    <b-form @submit.stop.prevent="addEmployeeToPf">
                        <div class="clearfix">
                            <div class="row clearfix">
                                <div class="col-md-12 float-left">
                                    <b-form-group id="device_id-group" label="Device ID" class="" label-for="device_id">
                                        <b-input-group>
                                              <!-- alpha fix- added class radius-8 to input field -->
                                            <b-form-input class="radius-8" id="device_id" name="device_id" v-model="pf_approve_date"
                                                v-validate="{ min: 3, max: 10 }" :state="validateState('device_id')"
                                                aria-describedby="device_id-feedback"
                                                data-vv-as="Device ID"></b-form-input>
                                            <b-form-invalid-feedback id="device_id-feedback">{{
                                                veeErrors.first('device_id') }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>

                         <!-- alpha fix- added class text-center and removed class float-right from the btn  -->
                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 0;">
                            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" type="submit"
                                variant="primary">Submit</b-button>
                        </div>
                    </b-form>
                </div>
            </b-modal>



        </b-overlay>

    </div>
</template>

<script>

export default {
    mounted() {
        //if(this.employeedata.last_working_day == '0000-00-00')
        //this.fdata.last_working_day = '';

        this.showoverlay = false;
    },
    props: ['flg'],
    components: {
    },
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const minDate = new Date(today);
        return {

            cu: window.location.href,
            successmsg: false,
            warningmsg: false,
            dangermsg: false,
            showoverlay: true,

            pf_start_date: '',
            errormsg: [],
            hide: false,
            checkbox: 1,

            show_loader: true,
            show_loader_2: true,
            show_loader_3: true,


            pf_del_id: 0,
            /* start pf signup variables */
            per_page: 20,
            application_lists: [],
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', nextbuttonstatus: 'true', prebuttonstatus: 'disabled' },
            application_loading: false,
            employeesearch: { name: '', status: 1 },
            users: [],
            em_tmp_custom_list: [],
            eligible_pf: 0,
            chosen_emp_id: 0,
            curr_emp_name: '',
            curr_emp_id: 0,
            curr_app_id: 0,
            last_payslip_date: '',
            pf_approve_date: '',
            min_date: minDate,
            pfoverlay: true,
            report_data: [],
            details: [],
            employee_info: [],



            /**Child Component property data */


            is_action: 1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
            list_key: 0, /* Component Key */
            custom_list: [],  /* Data List */
            default_column: ['name'], /* Default Column List */
            appended_column: [
                { value: "reg_applied_date", text: "Application Date", type: "text" },
                { value: "status", text: "Status", type: "text" },

            ],                   /* Appended Column List  and there title and type */
            primary_key: 'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
            company_options: [],         /* Company Filterable options */

            tmp_custom_list: [],

            custom_array: [],


            /***Child Component property data */





            /**Child Component property data */

            is_n_pf: 1,
            reg_is_action: 1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
            reg_list_key: 0, /* Component Key */
            reg_custom_list: [],  /* Data List */
            reg_default_column: ['name', 'email', 'jobposition', 'branch'], /* Default Column List */
            reg_appended_column: [
                { value: "device_id", text: "Device ID", type: "text" },
            ],                   /* Appended Column List  and there title and type */
            reg_primary_key: 'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
            reg_company_options: [],         /* Company Filterable options */

            reg_tmp_custom_list: [],

            reg_custom_array: [],

            em_reg_tmp_custom_list: [],
            em_reg_company_options: [],
            em_reg_list_key: 0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
            em_reg_primary_key: 'id',
            em_reg_default_column: ['name', 'email', 'jobposition', 'branch'], /* Default Column List */
            em_selected: [],
            selected: [],


            /***Child Component property data */


            curr_update_id: '',
            curr_approve_date: '',
            curr_update_employee: '',


        }
    },
    methods: {
        formatMe(d) {
            return moment(d).format('DD/MM/YYYY');
        },

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        /*start pf signup functions*/

        exportUpdatePFSelected: function () {
            if (this.em_selected == '')
                this.$bvToast.toast("No employee selected", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
            else {
                this.exportUpdatetPF('selected');
            }

        },

        exportUpdatetPF: function (sltd = '') {

            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });
            console.log(this.em_selected);

            const config = {
                responseType: 'blob'
            }

        },


        exportPFSelected: function () {
            if (this.selected == '')
                this.$bvToast.toast("No employee selected", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
            else {
                this.exportPF('selected');
            }

        },

        // Mustafijur: 12-05-2026
        exportPF: function(sltd='')
        {

            this.$bvToast.toast('It might take a while', {
                                    title: 'Info',
                                    variant: 'info',
                                    solid: true
                                });
            console.log(this.selected);

            this.showoverlay = true;
            let formData = new FormData();
            if(sltd.length>0 && this.selected)
            formData.append('employee_ids', this.selected);

            axios.post(this.$api_url+'/device-mapping/export/update', formData)
            .then(function (response)
            {
                this.showoverlay = false;
                //window.open(response.data);
                var fileURL = response.data;
                //this.download_file(fileURL);
                this.downloadFileContent(fileURL);

            }.bind(this))
            .catch(function (error)
            {
                currentObj.errormsg = error.response.data.errors;
            });

        },
        // Mustafijur: 12-05-2026




        addEmployeeToPf: function () {


            if (this.chosen_emp_id) {
                var curr_obj = this;

                let formData = new FormData();
                formData.append('employee_id', this.chosen_emp_id);
                formData.append('device_id', this.pf_approve_date);

                axios.post(this.$api_url + '/device-mapping/add-employee', formData)
                    .then(function (response) {
                        if (response.data.success) {
                            this.$bvToast.toast("Successfully updated", { title: 'Success', variant: 'success', solid: true });
                            curr_obj.employeesearch.name = "";
                            curr_obj.pf_start_date = "";
                            this.pf_approve_date = '';
                            curr_obj.chosen_emp_id = 0;
                            curr_obj.users = [];
                            this.pfgetEmployees();

                        } else if (response.data.errors) {
                            this.$bvToast.toast(response.data.errors, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                        }
                        this.$bvModal.hide('bv-modal-update-pf');
                        this.$bvModal.hide('bv-modal-register-pf');
                    }.bind(this))
                    .catch(function (error) {
                        currentObj.errormsg = error.response.data.errors;
                    });

            }

        },
        pfgetEmployees: function () {
            let currentObj = this;
            this.show_loader_3 = true;
            axios.get(this.$api_url + '/device-mapping/employees', {

            }).then(function (response) {


                /* Assingning the list */
                this.reg_tmp_custom_list = response.data.employee_data;
                /* Assingning the Options */
                this.reg_company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                this.reg_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                //console.log(this.reg_custom_list.length);

                if (this.reg_custom_list.length > 0) {
                    this.reg_custom_list.forEach(element => {

                        let dop = [];

                        if (element.device_id != '') {
                            dop = dop.concat([{ label: 'Update Device ID', value: 1 }]);
                        }
                        else {
                            dop = dop.concat([{ label: 'Add Device ID', value: 0 }]);
                        }


                        element.actions = dop;
                    });
                }

                // console.log('asdas');
                // console.log(this.reg_custom_list);

                //this.reg_custom_list = this.reg_tmp_custom_list;
                this.reg_list_key = this.list_key + 1;
                this.show_loader_3 = false;
            }.bind(this)).catch(function (error) {
                console.log(error);
                currentObj.serverError(error);

            });
        },



        reg_listReturn: function (data) {
            if (data.selected.length > 0) {
                this.selected = data.selected;
            }
            else {
                this.selected = [];

            }

            if (data.employee_id && data.action_id == 0) {

                let asd = this.reg_custom_list;
                this.chosen_emp_id = data.employee_id;

                var item = asd.find(item => item.employee_id === data.employee_id);
                this.curr_emp_name = item.name;
                this.pf_approve_date = item.device_id;

                this.$bvModal.show('bv-modal-register-pf');


            }

            if (data.employee_id && data.action_id == 1) {
                let asd = this.reg_custom_list;
                this.chosen_emp_id = data.employee_id;

                var item = asd.find(item => item.employee_id === data.employee_id);
                this.curr_emp_name = item.name;

                this.pf_approve_date = item.device_id;

                this.$bvModal.show('bv-modal-update-pf');


            }



        },




    },
    created: function () {
        if (!this.checkNet()) return false;
        this.$validator.reset();
        this.pfgetEmployees();
    }
}
</script>
